export default "__VITE_ASSET__egH978zI__"